import { User } from '@bioliberty/lifemind';
import { Pencil, RotateCw, Trash } from 'lucide-react';
import { useState } from 'react';
import { useAuthentication } from '../../auth';
import { IconButton } from '../../components/Button/IconButton';
import { isSuperAdmin } from '../../util/auth';
import { isInvitedUser } from '../utils';
import { DeleteUserModal } from '../views/DeleteUserModal';
import { EditUserModal } from '../views/EditUserModal';
import { ResendInviteUserModal } from '../views/ResendInviteModal';

export function UserActions(user: User) {
  const currentUser = useAuthentication();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showResendInviteModal, setShowResendInviteModal] = useState(false);

  const targetUserIsCurrentUser = user.id === currentUser.id;
  const targetUserHasElevatedRole = isSuperAdmin(user) && !isSuperAdmin(currentUser);

  return (
    <div className="flex">
      <EditUserModal {...user} open={showEditModal} onOpenChange={setShowEditModal} />
      <DeleteUserModal userId={user.id} email={user.email} open={showDeleteModal} onOpenChange={setShowDeleteModal} />
      <ResendInviteUserModal user={user} open={showResendInviteModal} onOpenChange={setShowResendInviteModal} />

      {isInvitedUser(user) ? (
        <IconButton
          onClick={() => setShowResendInviteModal(true)}
          variant="transparent"
          icon={RotateCw}
          testId="resend-user-invite-action-button"
        />
      ) : (
        <IconButton
          onClick={() => setShowEditModal(true)}
          variant="transparent"
          icon={Pencil}
          disabled={targetUserHasElevatedRole}
          testId="edit-user-action-button"
        />
      )}

      <IconButton
        onClick={() => setShowDeleteModal(true)}
        variant="danger"
        icon={Trash}
        disabled={targetUserIsCurrentUser || targetUserHasElevatedRole}
        testId="delete-user-action-button"
      />
    </div>
  );
}
